import { Company } from "./company";
import { Role } from "./role";
import { User } from "./user";
import { NameToRole, Role as RoleEnum, RoleName } from "../enums/role.enum";

export class UserGridViewItem {
    id?: string;
    login?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    company?: Company | null;
    creationDate?: Date;
    creationUser?: User;
    role?: Role;
    role_?: RoleEnum;
    roleName?: string;
    constructor(userGridViewItem?: UserGridViewItem) {
        this.id = userGridViewItem?.id;
        this.login = userGridViewItem?.login;
        this.firstName = userGridViewItem?.firstName;
        this.lastName = userGridViewItem?.lastName;
        this.email = userGridViewItem?.email;
        this.company = userGridViewItem?.company;
        this.creationDate = userGridViewItem?.creationDate;
        this.creationUser = userGridViewItem?.creationUser;
        this.role = userGridViewItem?.role;
        this.role_ = NameToRole.get(userGridViewItem?.role?.name || "");
        this.roleName = RoleName.get(this.role_ != null ? this.role_ : -1);
    }
}
